import { CSSProperties, useState } from "react";
import IconButton from "../../../elements/IconButton";
import {
  EmailFieldMap,
  ShareOptions,
} from "../SectionsAndLayoutsDrawer/ShareButtonConfig";
import EmailDrawer from "../EmailDrawer";
import { Module } from "../../../types/TenantInterfaces";

interface Props {
  module: Module;
  record: Record<string, any>;
  shareOptions?: ShareOptions[];
  style?: CSSProperties;
}

export default function ShareButton({
  module, // TODO: Use this for checking field types if needed in the future.
  record,
  shareOptions,
  style,
}: Props) {
  const [emailDrawer, setEmailDrawer] = useState<EmailFieldMap | null>(null);

  const ShareIconButton = (
    <IconButton
      style={style}
      icon="export-variant"
      color="primary"
      onClick={undefined}
    />
  );

  const Drawers = (
    <>
      <EmailDrawer
        open={emailDrawer !== null}
        onClose={() => setEmailDrawer(null)}
        subject={emailDrawer?.Subject}
        email={emailDrawer?.Body}
      />
    </>
  );

  if (shareOptions?.length === 1) {
    return (
      <>
        <div onClick={() => handleShare(shareOptions[0])}>
          {ShareIconButton}
        </div>
        {Drawers}
      </>
    );
  }

  // TODO: Add Whisper here in the future, when more share options are added.

  return null;

  function handleShare(option: ShareOptions) {
    if (option.Type === "Email") {
      const fieldMap = option.FieldMap;
      const emailValues: EmailFieldMap = {};

      for (const [emailField, fieldAPIName] of Object.entries(fieldMap)) {
        let recordValue;

        // Use RichText for Body, Plaintext for other fields (When selected field is RichText)
        if (emailField === "Body") {
          recordValue = record?.[fieldAPIName]?.RichText;
        } else {
          recordValue = record?.[fieldAPIName]?.PlainText;
        }

        recordValue = recordValue || record?.[fieldAPIName] || "";

        emailValues[emailField as keyof EmailFieldMap] = recordValue;
      }

      setEmailDrawer(emailValues);
    }
  }
}
